'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import BulkCreationView from './components/BulkCreationView';

export default function BulkCreationPage() {
  return (
    <AppLayout currentPath="/bulk-creation">
      <section
        className="min-h-screen bg-background px-6 lg:px-8 xl:px-10 py-6 max-w-screen-2xl mx-auto"
        aria-label="Bulk Creation"
      >
        <header className="mb-6">
          <p className="section-label mb-1">Content-Automatisierung</p>
          <h1 className="text-2xl font-800 text-white tracking-tight">Bulk Creation</h1>
          <p className="text-sm text-muted mt-1">
            Deine generierten <span className="text-accent font-600">Distortion-Posts</span> — bereit zum Teilen, Herunterladen und Veröffentlichen.
          </p>
        </header>
        <BulkCreationView />
      </section>
    </AppLayout>
  );
}
